module.exports = __webpack_public_path__ + "static/media/29.47feca3b.jpg";